var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.38403 9.00029V5.96585C4.39304 5.36938 4.51966 4.78057 4.75665 4.23311C4.99362 3.68566 5.3363 3.19036 5.76504 2.77556C6.19378 2.36078 6.70015 2.03466 7.25515 1.8159C7.81014 1.59714 8.40286 1.49004 8.99931 1.50073C9.59577 1.49004 10.1885 1.59714 10.7435 1.8159C11.2985 2.03466 11.8048 2.36078 12.2336 2.77556C12.6623 3.19036 13.005 3.68566 13.242 4.23311C13.4789 4.78057 13.6056 5.36938 13.6146 5.96585V9.00029",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38403 9.00029V5.96585C4.39304 5.36938 4.51966 4.78057 4.75665 4.23311C4.99362 3.68566 5.3363 3.19036 5.76504 2.77556C6.19378 2.36078 6.70015 2.03466 7.25515 1.8159C7.81014 1.59714 8.40286 1.49004 8.99931 1.50073C9.59577 1.49004 10.1885 1.59714 10.7435 1.8159C11.2985 2.03466 11.8048 2.36078 12.2336 2.77556C12.6623 3.19036 13.005 3.68566 13.242 4.23311C13.4789 4.78057 13.6056 5.36938 13.6146 5.96585V9.00029",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65382 7.26959H3.80764C3.96065 7.26959 4.10739 7.33037 4.21557 7.43856C4.32377 7.54674 4.38455 7.69348 4.38455 7.84648V11.3078C4.38455 11.4608 4.32377 11.6076 4.21557 11.7157C4.10739 11.8239 3.96065 11.8847 3.80764 11.8847H2.65382C2.3478 11.8847 2.05433 11.7631 1.83795 11.5468C1.62156 11.3304 1.5 11.0369 1.5 10.7309V8.42337C1.5 8.11737 1.62156 7.8239 1.83795 7.60752C2.05433 7.39115 2.3478 7.26959 2.65382 7.26959Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65382 7.26959H3.80764C3.96065 7.26959 4.10739 7.33037 4.21557 7.43856C4.32377 7.54674 4.38455 7.69348 4.38455 7.84648V11.3078C4.38455 11.4608 4.32377 11.6076 4.21557 11.7157C4.10739 11.8239 3.96065 11.8847 3.80764 11.8847H2.65382C2.3478 11.8847 2.05433 11.7631 1.83795 11.5468C1.62156 11.3304 1.5 11.0369 1.5 10.7309V8.42337C1.5 8.11737 1.62156 7.8239 1.83795 7.60752C2.05433 7.39115 2.3478 7.26959 2.65382 7.26959Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3457 11.8847H14.1919C14.0389 11.8847 13.8921 11.8239 13.7839 11.7157C13.6758 11.6076 13.615 11.4608 13.615 11.3078V7.84648C13.615 7.69348 13.6758 7.54674 13.7839 7.43856C13.8921 7.33037 14.0389 7.26959 14.1919 7.26959H15.3457C15.6517 7.26959 15.9452 7.39115 16.1616 7.60752C16.3779 7.8239 16.4995 8.11737 16.4995 8.42337V10.7309C16.4995 11.0369 16.3779 11.3304 16.1616 11.5468C15.9452 11.7631 15.6517 11.8847 15.3457 11.8847Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3457 11.8847H14.1919C14.0389 11.8847 13.8921 11.8239 13.7839 11.7157C13.6758 11.6076 13.615 11.4608 13.615 11.3078V7.84648C13.615 7.69348 13.6758 7.54674 13.7839 7.43856C13.8921 7.33037 14.0389 7.26959 14.1919 7.26959H15.3457C15.6517 7.26959 15.9452 7.39115 16.1616 7.60752C16.3779 7.8239 16.4995 8.11737 16.4995 8.42337V10.7309C16.4995 11.0369 16.3779 11.3304 16.1616 11.5468C15.9452 11.7631 15.6517 11.8847 15.3457 11.8847Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3071 15.0576C11.9191 15.0576 12.5061 14.8145 12.9389 14.3817C13.3717 13.9489 13.6148 13.362 13.6148 12.7501V10.1541",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3071 15.0576C11.9191 15.0576 12.5061 14.8145 12.9389 14.3817C13.3717 13.9489 13.6148 13.362 13.6148 12.7501V10.1541",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3074 15.0578C11.3074 15.4402 11.1555 15.8071 10.885 16.0776C10.6145 16.348 10.2477 16.5 9.86514 16.5H8.13441C7.7519 16.5 7.38505 16.348 7.11458 16.0776C6.8441 15.8071 6.69214 15.4402 6.69214 15.0578C6.69214 14.6753 6.8441 14.3084 7.11458 14.0379C7.38505 13.7675 7.7519 13.6155 8.13441 13.6155H9.86514C10.2477 13.6155 10.6145 13.7675 10.885 14.0379C11.1555 14.3084 11.3074 14.6753 11.3074 15.0578Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3074 15.0578C11.3074 15.4402 11.1555 15.8071 10.885 16.0776C10.6145 16.348 10.2477 16.5 9.86514 16.5H8.13441C7.7519 16.5 7.38505 16.348 7.11458 16.0776C6.8441 15.8071 6.69214 15.4402 6.69214 15.0578C6.69214 14.6753 6.8441 14.3084 7.11458 14.0379C7.38505 13.7675 7.7519 13.6155 8.13441 13.6155H9.86514C10.2477 13.6155 10.6145 13.7675 10.885 14.0379C11.1555 14.3084 11.3074 14.6753 11.3074 15.0578Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.716a373560afd457269559c4662d5212.svg";
export { ForwardRef as ReactComponent };